import values from 'ramda/src/values';
import sortBy from 'ramda/src/sortBy';
import prop from 'ramda/src/prop';
import pipe from 'ramda/src/pipe';

const sortByName = sortBy(prop('name'));
export const getDiscounts = state => sortByName(values(state.settings.discounts));
export const byId = (state, id) => state.settings.discounts[id];
export const getDiscountName = pipe(byId, prop('name'));
